<template>
  <section>
    <v-form v-model='valid' ref='form' lazy-validation>
    <v-dialog v-model='repetidosModal' scrollable persistent max-width='850'>
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title><h4>Formulario de Verificación de Presentación de DJBR</h4></v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
           </v-toolbar>          
          <v-card-text>
            <br>       
            <v-layout wrap>
              <v-flex sm6 md6>
                <v-select
                  v-model='tipoDocumento'
                  :items='itemTipoDocumento'
                  item-text='tipo_documento'
                  item-value='tipo_documento_codigo'
                  label='Documento de Identificación'
                  prepend-icon="credit_card"              
                  :rules='dRules'
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <div v-if='tipoDocumento==3'>
              <v-layout wrap>
                <v-flex sm6 md4>
                  <v-text-field
                    v-model='prefijo'
                    prepend-icon="keyboard_arrow_left"
                    label='Prefijo Alfanumérico Pasaporte*'
                    maxlength='4'
                  ></v-text-field>
                </v-flex>
                <v-flex sm6 md4>
                  <v-text-field
                    v-model='valor'
                    prepend-icon="fingerprint"
                    label='Valor Númerico de Pasaporte*'
                    maxlength='15'
                    :rules='valorRules'
                  ></v-text-field>
                </v-flex>
                <v-flex sm6 md4>
                  <v-text-field
                    v-model='sufijo'
                    label='Sufijo Alfanumérico Pasaporte*'
                    prepend-icon="keyboard_arrow_right"
                    maxlength='4'
                    class='my-input'
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div v-if='tipoDocumento==1'>
              <v-layout wrap>
                <v-flex sm6 md6>
                  <v-text-field v-model='ci' label='Nro CI*' maxlength='15' prepend-icon="fingerprint" :rules='ciRules'></v-text-field>
                </v-flex>
                <v-flex sm6 md6>
                  <v-text-field
                    prepend-icon="fingerprint"
                    v-model='complemento'
                    :rules='complementoRules'
                    label='Complemento SEGIP'
                    maxlength='2'
                    class="text-normal"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <v-layout wrap>
              <v-flex sm6 md6>
                <global-date-input-picker
                  v-model="date" :hint="'Formato DD/MM/AAAA'" :rules="dateRulesF" label="Fecha de Nacimiento*">
                </global-date-input-picker>
              </v-flex>
            </v-layout>
            <br />
      <v-layout wrap>
        <v-flex sm12 md12>
          <v-subheader>
            <p class='plomo--text'>Por favor llene los campos requeridos*</p>
          </v-subheader>
        </v-flex>
      </v-layout>
            <v-layout wrap>
              <p>Digite la letras y/o números que aparecen en la imagen </p>
              <v-layout row wrap>
                <v-flex md3 offset-md1>
                  <img
                    :src="imgb64"
                    alt="Bolivia">
                </v-flex>
                <v-flex md4 offset-md1>
                  <v-text-field
                    v-model="captcha"
                    :rules='this.useCaptcha ? dRules : []'
                    label='Respuesta'
                    :required="this.useCaptcha"
                    :maxlength="this.lengthCaptcha"
                  ></v-text-field>
                </v-flex>
                <v-flex md1>
                  <v-icon large @click="crearImagenCaptcha()">cached</v-icon>                  
                </v-flex>
              </v-layout>  
            </v-layout>
            <br />
            <div class='center' v-if="respuesta.estado!=''">
              <div class='alert'>
                Estado de
                <b>{{ respuesta.estado }}</b> en fecha
                <b>{{ respuesta.fecha }}</b>
              </div>
            </div>
            <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn :loading="loading" color='primary' @click='verificar()'><v-icon>beenhere</v-icon>&nbsp;Verificar</v-btn>
            <v-btn :loading="loading" color='error' @click='cancel()'><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
          </v-card-actions>
          </v-card-text>
        </v-card>
    </v-dialog>
    </v-form>
    <div class="centered">
      <v-layout wrap>
        <v-flex md12>
          <v-btn color="transparent" fab large @click='repetidosModal = true'>
            <v-icon
              size="100"
              color="white"
            >
              insert_drive_file
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <br>
      <v-layout wrap>
        <v-flex md12>
          <p class="padding-label" style="color:white;">
            <br><b>Verificación de
            <br/>Recepción de Declaraciones</b>
          </p>
        </v-flex>
      </v-layout>
    </div>
  </section>
</template>
<script>
import Captcha from './mixins/captcha.js';
import PdfView from '@/common/util/PdfView.vue';
export default {
  components: {
    PdfView
  },
  mixins: [ Captcha ],
  created () {
    this.crearImagenCaptcha();
    const req = this.$route.query.dmFsaWRhY2lvbmNlcnRpZmljYWRv;
    if (req) {
      const buff = Buffer.from(req, 'base64');
      const text = buff.toString('ascii');
      if (text.search(':') > 0) {
        const [codigoControl, date] = text.split(':');
        this.date = date;
        this.codigoControl = codigoControl;
        this.buscar();
      }
    }
  },
  data: () => ({
    tipoDocumento: -1,
    itemTipoDocumento: [
      {
        tipo_documento: 'Cédula de Identidad',
        tipo_documento_codigo: 1
      },
      {
        tipo_documento: 'Pasaporte',
        tipo_documento_codigo: 3
      }
    ],
    complemento: '',
    prefijo: '',
    valor: '',
    sufijo: '',
    ci: '',
    date1: '',
    menu: false,
    valid: false,
    numeroDocumento: '',
    sufijoNumero: '',
    activeBtn: 1,
    repetidosModal: false,
    estadoP: '',
    tipoP: '',
    respuesta: {
      fecha: '',
      estado: '',
      tipo: ''
    },
    captcha: '',
    imgb64: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    date: '',
    dRules: [v => !!v || 'Este campo es requerido'],
    valorRules: [
      v => !!v || 'Este campo es requerido ci',
      v => /^[0-9]*$/.test(v) || 'El número de ci no es válido'
    ],
    pasaporteRules: [
      v => !!v || 'Este campo es requerido pasaporte',
      v =>
        /^[A-Za-z0-9]{1,4}-[0-9]{1,10}$/.test(v) ||
        'El número de pasaporte no es válido'
    ],
    ciRules: [
      v => !!v || 'Este campo es requerido ci',
      v => /^[0-9]*$/.test(v) || 'El número de ci no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[BE]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición',
      v => (!/^[PD]+$/.test(v)) || 'El complemento corresponde a un departamento de expedición'
    ],
    dateRulesF: [v => !!v || 'Este campo es requerido',
      v => ((v || '').length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos',
      v => (v && /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || 'Fecha no válida'],
    loading: false
  }),
  methods: {
    async crearImagenCaptcha () {
      this.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    verificar () {
      if (this.complemento === 'lp' || this.complemento === 'cb' || this.complemento === 'sc' ||
          this.complemento === 'pt' || this.complemento === 'or' || this.complemento === 'ch' ||
          this.complemento === 'tj' || this.complemento === 'bn' || this.complemento === 'pn') {
        this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
        this.complemento = '';
      }
      if (this.$refs.form.validate()) {
        // let verify = this.verificarCaptcha(this.useCaptcha, this.tokenCaptcha, this.form.captcha);
        // if (verify) {
        this.loading = true;
        if (this.tipoDocumento === 1) {
          this.numeroDocumento = this.ci;
          this.sufijoNumero = this.complemento.toUpperCase();
        } else {
          this.numeroDocumento = this.valor;
          this.sufijoNumero = this.sufijo.toUpperCase();
        }
        let valida = this.validar();
        if (valida === 1) {
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service
            .get(
              `djbr_registro/declaracion_jurada_publico?prefijo_documento=${this.prefijo}&sufijo_documento=${this.sufijoNumero}&tipo_documento=${this.tipoDocumento}&nro_documento=${this.numeroDocumento}&fecha_nacimiento=${this.date}&token=${this.tokenCaptcha}&captcha=${this.captcha}`,
              {}
            )
            .then(response => {
              this.$storage.remove('token');
              this.respuesta.estado = '';
              this.respuesta.tipo = '';
              this.respuesta.fecha = '';
              if (response) {
                this.crearImagenCaptcha();
                this.respuesta.fecha = response.decjur_fecha_declaracion;
                this.control = 1;
                if (response.decjur_estado === 0) {
                  this.estadoP = 'Declaración Jurada dado de baja';
                  this.tipoP = 'error';
                }
                if (response.decjur_estado === 1) {
                  this.estadoP = 'Declaración Jurada en proceso';
                  this.tipoP = 'info';
                }
                if (response.decjur_estado === 2) {
                  this.estadoP = 'Declaración Jurada finalizado';
                  this.tipoP = 'warning';
                }
                if (response.decjur_estado === 3) {
                  this.estadoP = 'Declaración Jurada recepcionada';
                  this.tipoP = 'success';
                }
                this.respuesta.estado = this.estadoP;
                this.respuesta.tipo = this.tipoP;
                if (response.error_existente === 1) {
                  this.$message['warning'](response.error_mensaje);
                }
                this.loading = false;
              } else {
                this.crearImagenCaptcha();
                this.loading = false;
              }
            }).catch(err => {
              this.$message['error'](err.error_mensaje);
              this.loading = false;
            });
          this.$storage.remove('token');
        }
        // } else {
        //   this.crearImagenCaptcha();
        //   this.$message['warning']('el código ingresado no es correcto, vuelva a ingresar el código');
        //   this.respuesta.estado = '';
        // }
      } else {
        this.$message['warning']('Verificación Incorrecta, Datos requeridos incompletos.');
        this.loading = false;
      }
    },
    validar () {
      if (this.numeroDocumento === '') {
        if (this.tipoDocumento === 1) {
          this.$message['warning']('Debe ingresar el Número de su documento.');
        } else {
          this.$message['warning']('Valor Númerico de Pasaporte.');
        }
        return 0;
      } else {
        return 1;
      }
    },
    cancel () {
      this.loading = false;
      this.repetidosModal = false;
      this.setearDatos();
      this.crearImagenCaptcha();
      this.$refs.form.resetValidation();
    },
    setearDatos () {
      this.respuesta.estado = '';
      this.respuesta.tipo = '';
      this.respuesta.fecha = '';
      this.ci = '';
      this.complemento = '';
      this.menu = '';
      this.date = '';
      this.valor = '';
      this.sufijo = '';
      this.prefijo = '';
      this.tipoDocumento = -1;
      this.tokenCaptcha = '';
      this.captcha = '';
    },
    iniciar () {
      this.crearImagenCaptcha();
      this.setearDatos();
      this.repetidosModal = true;
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
};
</script>
<style lang='scss'>
.alert {
  padding: 20px;
  background-color: #2196f3;
  color: white;
}
.centered {
  text-align: center;
  h2 {
    color: #3572af;
  }
  line-height: 1;
}
.el-button-login {
  width: 250px !important;
}
.my-input input {
  text-transform: uppercase;
}
/*
.padding-space {
  padding-top: 10px;
  padding-bottom: 10px;
}
*/
</style>


// WEBPACK FOOTER //
// src/components/portal/verificacion.vue